import { createSelector } from 'reselect';
import { editionSelector, intlAppSelector } from 'common/selectors/appSelector';

const adsSelector = ({ ads = {} }) => ads;

export default createSelector(adsSelector, (ads) => ads);

export const adSiteSelector = createSelector(
    editionSelector,
    intlAppSelector,
    ({ ad }, intlApp) => (
        intlApp ? 'm.app.espnplay' : ad.site
    )
);



// WEBPACK FOOTER //
// ./app/common/selectors/adsSelector.js